import { useState } from 'react'
import { DiscountForm } from '../DiscountForm'
import Plus from '@/svgs/plus.svg'
import Minus from '@/svgs/minus.svg'

const DiscountSection = () => {
  const [discountOpen, setDiscountOpen] = useState(true)

  return (
    <>
      <div
        className= "checkout__header"
      >
        <div className="checkout__header-wrap">
          <h6>Have a discount code?</h6>
        </div>
        <button
          onClick={() => setDiscountOpen(!discountOpen)}
          className="checkout__header-toggle-btn"
        >
          {discountOpen ? <Minus className="icon" /> : <Plus className="icon" />}
        </button>
      </div>
      {!!discountOpen && <DiscountForm />}
    </>
  )
}

export default DiscountSection
